import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const FirstYearAmountPicker = ({ resource }) => {
  return resource.withRelationship(
    fr.relationships.estatePlanningDiscount.name,
    () => (
      <FDStack direction="row" spacing={0.75}>
        <MetaControlField attr={'firstYearAmountWithDiscount'} />
      </FDStack>
    ),
    () => <MetaControlField attr={'firstYearAmount'} />,
  );
};

FirstYearAmountPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
FirstYearAmountPicker.defaultProps = {
};

export default FirstYearAmountPicker;
